import { useQuery, useMutation } from "react-query";
import { Activity, Klass, Session } from "../types";
import firebase from "firebase";
import { nanoid } from "nanoid";

const useClasses = () => {
  const { isLoading, error, data, refetch } = useQuery<Klass[]>("classes", () =>
    firebase
      .firestore()
      .collection("classes")
      .get()
      .then((snapshot) => {
        const classes: Klass[] = [];
        snapshot.forEach((doc) => {
          const data = doc.data() as Klass;
          classes.push({ ...data, id: doc.id });
        });
        return classes;
      })
  );

  const { mutate: addClassToFirebase } = useMutation(
    "klasses",
    async (variables: Klass) => {
      const id = nanoid();
      await firebase
        .firestore()
        .collection("classes")
        .doc(id)
        .set({ ...variables, id })
        .then(() => refetch());
      return variables;
    }
  );

  const { mutate: removeClass } = useMutation("klasses", async (id: string) => {
    await firebase
      .firestore()
      .collection("classes")
      .doc(id)
      .delete()
      .then(() => refetch());
  });

  const addSessionToClass = async (session: Session, klass: Klass) => {
    const nextClass: Klass = {
      ...klass,
      sessions: [...(klass?.sessions || []), session],
    };
    await firebase
      .firestore()
      .collection("classes")
      .doc(klass.id)
      .update({
        sessions: nextClass.sessions,
      })
      .then(() => refetch());
    return nextClass;
  };

  const addActivityToClass = async (activity: Activity, klass: Klass) => {
    const nextClass: Klass = {
      ...klass,
      activities: [...(klass?.activities || []), activity],
    };
    await firebase
      .firestore()
      .collection("classes")
      .doc(klass.id)
      .update({
        activities: nextClass.activities,
      })
      .then(() => refetch());
    return nextClass;
  };

  return {
    isLoading,
    error,
    data,
    addClassToFirebase,
    addSessionToClass,
    addActivityToClass,
    removeClass,
  };
};

export default useClasses;
